import { Crumb } from '../breadCrumbs/BreadcrumbHandler';

const breadcrumbStructuredData = (crumbs: Array<Crumb>, allowSingle: boolean = false) => {
  if(crumbs.length <= (allowSingle ? 0 : 1)){
    return null;
  }
  const itemList = crumbs.map(
    (crumb: Crumb,i:number) => {
      return {
        "@type": "ListItem",
        "position": (i+1),
        "item": process.env.GATSBY_SITE_URL+crumb.path,
        "name": crumb.label,
      }
    }
  )

  const structuredData: any = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": itemList
  }
  return JSON.stringify(structuredData);
}

export default breadcrumbStructuredData;